import { Injectable } from '@angular/core';
import { Admin } from '@wb/core/interfaces/admin';
import { gql, Query } from 'apollo-angular';

export interface AdminResponse {
  admin: {
    code: string;
    success: boolean;
    message: string;
    admin: Admin;
  };
}

@Injectable({
  providedIn: 'root',
})
export class AdminGQL extends Query<AdminResponse, { uid: string }> {
  document = gql(`
    query admin($uid: ID!) {
      admin(uid: $uid) {
        code
        success
        message
        admin {
          first_name
          last_name
          email
          phone_number
          settings
          agree_terms
          uid
          token
          status
          image
          accountUid
          privilege
          image_key
          last_login
          user_settings {
            key
            value
          }
          permissions {
            uid
            accountUid
            accountTitle
            title
            access_type
            description
            permission
          }
        }
      }
    }
  `);
}

export interface IsUserSelectableResponse {
  isSelectable: {
    code: string;
    success: boolean;
    message: string;
    selectable: boolean;
  };
}

@Injectable({
  providedIn: 'root',
})
export class IsUserSelectableGQL extends Query<IsUserSelectableResponse> {
  document = gql(`
    query isSelectable($uid: ID!) {
      isSelectable(uid: $uid) {
        code
        success
        message
        selectable
      }
    }
  `);
}
